// import COMPANY_API from '@/api/masterData/company.js';

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'payableSettlementNo',
    title: '结算单编号',
    width: '120',
    visible: true,
  },
  {
    field: 'settlementCompanyName',
    title: '公司名称',
    width: '120',
    visible: true,
  },
  {
    field: 'settlementDepartmentName',
    title: '部门',
    width: '120',
    visible: true,
  },
  {
    field: 'settlementBusinessType',
    title: '业务类别',
    width: '120',
    visible: true,
  },
  {
    field: 'supplierName',
    title: '供应商',
    width: '120',
    visible: true,
  },
  {
    field: 'settlementCenterName',
    title: '结算中心',
    width: '120',
    visible: true,
  },
  {
    field: 'settlementDate',
    title: '结算日期',
    width: '120',
    visible: true,
  },
  {
    field: 'originalTotalAmount',
    title: '原币结算金额（含税）',
    width: '150',
    visible: true,
  },
  {
    field: 'originalTotalAmountWithoutTax',
    title: '原币结算金额（不含税）',
    visible: true,
    width: '170',
  },
  {
    field: 'domesticTotalAmount',
    title: '本币结算金额（含税）',
    width: '150',
    visible: true,
  },
  {
    field: 'domesticTotalAmountWithoutTax',
    title: '本币结算金额（不含税）',
    visible: true,
    width: '170',
  },
  {
    field: 'payableAccountPeriod',
    title: '应付账期',
    width: '120',
    visible: true,
  },
  {
    field: 'projectInitiationNo',
    title: '项目编号',
    width: '120',
    visible: true,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    width: '120',
    visible: true,
  },

  {
    field: 'settlementStatus',
    title: '结算单状态',
    width: '120',
    visible: true,
  },
  {
    field: 'paymentStatus',
    title: '付款状态',
    width: '120',
    visible: true,
  },
  {
    field: 'paidAmount',
    title: '付款金额',
    width: '120',
    visible: true,
  },
  {
    field: 'unpaidAmount',
    title: '未付款金额',
    width: '120',
    visible: true,
  },
  {
    field: 'printFlag',
    title: '是否已打印',
    width: '120',
    visible: true,
  },
  {
    field: 'salesmanName',
    title: '业务员',
    width: '120',
    visible: true,
  },
];
